import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
} from 'rxjs/operators';
import { 
  TAX_FIND,
  TAX_FIND_SUCCESS,
  TAX_FAILED,
  TAX_UPDATE_ID,
 } from '../actions'
import { TaxService } from '@core/services';

@Injectable()
export class TaxEffects {
  constructor(
    private actions$: Actions,
    private taxService: TaxService,
  ) {}

  find$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TAX_FIND),
      mergeMap(() =>
        this.taxService.findTaxs().pipe(
          mergeMap(({ data }) => {
            const [tax] = data; 
            return [
              TAX_UPDATE_ID({ taxId: tax.idImpuesto }),
              TAX_FIND_SUCCESS({tax: data}),
            ];
          }),
          catchError((error) =>
            of(
              TAX_FAILED({
                error: error.error?.message || 'Error loading local canals',
              })
            )
          )
        )
      )
    )
  );
}
